import { render, staticRenderFns } from "./edit.vue?vue&type=template&id=909e8360"
import script from "./edit.ts?vue&type=script&lang=js&external"
export * from "./edit.ts?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/1/s/TafStore.PharmUP.Client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('909e8360')) {
      api.createRecord('909e8360', component.options)
    } else {
      api.reload('909e8360', component.options)
    }
    module.hot.accept("./edit.vue?vue&type=template&id=909e8360", function () {
      api.rerender('909e8360', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/parent/crud/kitembalagem/edit.vue"
export default component.exports